import { render, staticRenderFns } from "./ChurnAnalysis.vue?vue&type=template&id=dc5a20ba&scoped=true"
import script from "./ChurnAnalysis.vue?vue&type=script&lang=ts"
export * from "./ChurnAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./ChurnAnalysis.vue?vue&type=style&index=0&id=dc5a20ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5a20ba",
  null
  
)

export default component.exports